<template>
    <section>
        <div class="filters">

            <span class="icon-holder leading-normal font-medium text-cerulean cursor-pointer" v-on:click.prevent="downloadList">
                Download list
                <span class="svg-icon bg-contain w-4 h-4" aria-hidden="true"
                      :style="'background-image: url('+downloadImageLocation+')'"></span>
            </span>
        </div>


        <table class="mobile-table no-stripe tbody-stripe">
            <thead>
                <tr>
                    <th>Start date</th>
                    <th>End date</th>
                    <th>Meeting</th>
                    <th>Meeting type</th>
                    <th>Presence</th>
                    <th></th>
                </tr>
            </thead>
            <tbody v-if="$apollo.queries.readEventDescriptionPages.loading">
                <tr>
                    <th colspan="9">
                        <i class="svg-icon bg-contain w-4 h-4 -refresh animate-spin" aria-hidden="true"
                           :style="'background-image: url('+refreshImageLocation+')'"></i>
                        Loading....
                    </th>
                </tr>
            </tbody>
            <tbody v-else v-for="page in readEventDescriptionPages" v-on:click="goTo(page.node.link)" class="cursor-pointer border-b border-b-light-grey hover:bg-light-gray">
                <tr class="border-b-0 bg-transparent">
                    <td colspan="6">
                        <h3 class="text-normal">
                            <a :href="page.node.link" class="no-underline">
                            {{ page.node.title }}
                            </a>
                        </h3>
                    </td>
                </tr>
                <tr class="bg-transparent">
                    <td>{{ page.node.eventStartDate }}</td>
                    <td>{{ page.node.eventEndDate }}</td>
                    <td>
                        <a :href="page.node.link">
                        {{ page.node.eventCode }}
                        </a>
                    </td>
                    <td>{{ page.node.meetingType }}</td>
                    <td>
                        <span class="icon-holder" v-if="page.node.presence === 'virtual'">
                            <img :src="globeImageLocation" alt="Virtual" class="w-4 h-4"> Virtual
                        </span>
                        <span class="icon-holder" v-if="page.node.presence === 'face-to-face'">
                            <img :src="usersImageLocation" alt="Face to face" class="w-4 h-4"> Face to Face
                        </span>
                        <span class="icon-holder" v-if="page.node.presence === 'hybrid'">
                            <img :src="globeImageLocation" alt="Virtual" class="w-4 h-4"> / <img :src="usersImageLocation" alt="Face to face" class="w-4 h-4"> Hybrid
                        </span>
                    </td>
                    <td>
                        <a :href="page.node.link">
                            <i class="svg-icon bg-contain w-4 h-4" aria-hidden="true"
                               :style="'background-image: url('+linkImageLocation+')'"></i>
                        </a>
                    </td>
                </tr>
            </tbody>
        </table>

    </section>
</template>

<script>

import gql from "graphql-tag";

export default {
    name: "EventListingPanel",
    props: {
        showArchiveOnly: {
            type: String,
            default: "false"
        },
        globeImageLocation: {
            type: String,
            default: ""
        },
        usersImageLocation: {
            type: String,
            default: ""
        },
        downloadImageLocation: {
            type: String,
            default: ""
        },
        linkImageLocation: {
            type: String,
            default: ""
        },
        refreshImageLocation: {
            type: String,
            default: ""
        }
    },
    computed: {
        showArchiveOnlyBoolean: function () {
                return (this.showArchiveOnly === '1');
        }
    },
    methods: {
        goTo: function (url) {
            window.location.href = url;
        },
        downloadList: function () {
            //export the contents of this.readEventDescriptionPages to a csv file
            let csv = 'Title,Start date,End date,Registration start,Registration end,Meeting,Meeting type,Presence,Location\n';
            this.readEventDescriptionPages.forEach(page => {
                csv += `${page.node.title},${page.node.eventStartDate},${page.node.eventEndDate},${page.node.registrationStart},${page.node.registrationEnd},${page.node.eventCode},${page.node.meetingType},${page.node.presence},${page.node.location}\n`;
            });

            // Create a Blob from the CSV data
            const blob = new Blob([csv], {type: 'text/csv'});
            const url = URL.createObjectURL(blob);

            // Create a temporary anchor element to trigger the download
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = 'iecex-meetings-download-list.csv';
            anchor.click();

            // Clean up the URL object
            URL.revokeObjectURL(url);
        }
    },
    apollo: {
        readEventDescriptionPages: {
            query: gql`
                query readEventDescriptionPages($showpasteventsonly: Boolean!) {
                  readEventDescriptionPages (filter: {inactiveEvent: {eq: $showpasteventsonly}})  {
                    edges {
                      node {
                        id
                        title
                        eventCode
                        eventStartDate
                        eventEndDate
                        eventSummary
                        featuredEvent
                        inactiveEvent
                        registrationStart
                        registrationEnd
                        meetingType
                        presence
                        inactiveEvent
                        link
                      }
                    }
                  }
                }
            `,
            variables() {
                return {
                    showpasteventsonly: this.showArchiveOnlyBoolean
                }
            },
            update: function (data) {
                return data.readEventDescriptionPages.edges;
            },
            fetchPolicy: 'cache-and-network'
        },
    }
}

</script>

<style scoped>

</style>
